import { debounce, DebouncedFunction } from '@pogokid/util'
import { DependencyList, useCallback, useMemo } from 'react'

/**
 * Create a debounced function with dependencies
 *
 * ```
 * const fn = useDebounceFn((e) => {
 *   setY(e.clientY)
 * }, 100, [setY])
 * ```
 *
 * @param fn   The function to debounce
 * @param ms   The wait period in ms
 * @param deps useCallback dependencies
 */
export function useDebounceFn<
  Args extends any[],
  F extends (...args: Args) => any
>(
  fn: F,
  ms: number,
  deps: DependencyList = []
): DebouncedFunction<Args, F> {
  const cb = useCallback<F>(fn, deps)
  return useMemo(() => debounce(cb, ms), [cb, ms])
}
